import {
  Component,
  DestroyRef,
  ElementRef,
  afterNextRender,
  inject,
  viewChild,
} from '@angular/core';

export interface WordsStripItem {
  word: string;
  icon: string;
  iconWidth?: number;
  iconHeight?: number;
}

@Component({
  selector: 'app-words-strip',
  standalone: true,
  templateUrl: './words-strip.html',
  styleUrl: './words-strip.scss',
})
export class WordsStripComponent {
  private readonly destroyRef = inject(DestroyRef);
  readonly trackRef = viewChild.required<ElementRef<HTMLElement>>('track');

  readonly stripItems: WordsStripItem[] = [
    { word: 'Crear', icon: 'icon-rombo.svg' },
    { word: 'Sentir', icon: 'icon-circulos.svg', iconHeight: 34 },
    { word: 'Explorar', icon: 'icon-sun.svg' },
    { word: 'Compartir', icon: 'icon-rombo.svg' },
    { word: 'Soltar', icon: 'icon-circulos.svg', iconHeight: 34 },
    { word: 'Conectar', icon: 'icon-sun.svg' },
  ];

  readonly stripCopies = [0, 1] as const;

  constructor() {
    afterNextRender(() => {
      const track = this.trackRef().nativeElement;
      let observer: ResizeObserver | undefined;

      const updateShift = () => {
        const sets = track.querySelectorAll<HTMLElement>('.words-strip__set');
        if (sets.length < 2) return;

        const shift = sets[1].offsetLeft;
        if (shift <= 0) return;

        track.style.setProperty('--marquee-shift', `${shift}px`);
      };

      updateShift();
      requestAnimationFrame(updateShift);

      observer = new ResizeObserver(updateShift);
      observer.observe(track);
      track.querySelectorAll('.words-strip__set').forEach((set) => {
        observer!.observe(set);
      });

      document.fonts?.ready.then(updateShift);

      this.destroyRef.onDestroy(() => observer?.disconnect());
    });
  }
}
